export class UnsubscribeProposal {
  public UnsubscribeReq: mdlUnsubscribeReq = new mdlUnsubscribeReq();
  public UnsubscribeRes: mdlUnsubscribeRes = new mdlUnsubscribeRes();
}

export class mdlUnsubscribeReq {
  Email: string = '';
  UnsubscribeReasonCode: number | null = null; 
  InsuredName: string;
  InsuredIdNo: string;
  MobileNo: string;  
  RegNo: number | null = null;
  Channel: string;
  OtherReason: string;
}

export class mdlUnsubscribeRes {
  StatusCode: string;
  StatusDesc: string;
  StatusDescAr: string; 
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/UnsubscribeProposal.ts